<template>
    <div class="md:tw-inline-block tw-relative">

        <button id="actionsMenuInboxButton" @click="isDropdownOpen = ! isDropdownOpen" class="cu-btn tw-relative tw-mb-1">
            <i class="fa fa-spinner fa-pulse tw-mr-1" v-show="isLoading"></i>
            Aktion
            <i class="fa fa-chevron-down tw-ml-1"></i>
        </button>

        <div id="myDropdown" style="min-width: 250px;"
             class="dropdown-content tw-bg-white tw-absolute tw-overflow-auto tw-z-20 tw-rounded-md tw-pt-2 tw-pb-2 tw-border tw-border-navbar-secondary"
             v-show="isDropdownOpen"
             v-closable="{
                exclude: ['#actionsMenuInboxButton'],
                handler: 'onClose'
            }"
        >

            <div class="tw-flex tw-flex-wrap">
                <a 
                    :href="answer_url"
                    class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                >
                    <span>Antworten</span>
                </a>

                <button type="button" 
                    class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                    data-toggle="modal" data-target="#edit-mail"
                >
                    <span>Bearbeiten</span>
                </button>

                <button type="button" 
                    class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                    aria-label="Left Align" @click="deleteMail();"
                >
                    <span class="">Löschen</span>
                </button>
                
                <button type="button" 
                    class="focus:tw-no-underline hover:tw-no-underline tw-no-underline tw-block tw-w-full tw-py-2 tw-px-4 hover:tw-bg-brand-primary hover:tw-text-white tw-cursor-pointer tw-text-left tw-text-black focus:tw-text-black"
                    aria-label="Left Align" @click="hardDeleteMail();"
                >
                    <span class="">Löschen (Hart)</span>
                </button>
            </div>

            <hr class="tw-my-2">

            <div class="tw-flex-wrap">
                <div class="tw-px-4 tw-mb-2">
                    als E-Mail weiterleiten
                </div>
                <div class="tw-px-4 tw-mb-2 cu-input-simple">
                    <input type="email" name="email" id="forward_email" placeholder="E-Mail Adresse" required>
                </div>
                <div class="tw-px-4">
                    <button type="button" class="cu-btn-sm" @click="forwardMail()">Senden</button>
                </div>
            </div>

            <template v-if="merges !== null">
                <hr class="tw-my-2">

                <div class="tw-px-4">
                    <h2 class="">Mit Bewerbung zusammenfassen</h2>

                    <div class="cu-input-simple tw-mt-2 tw-w-full">
                        <select id="merge_in_id" required>
                            <template v-for="merge in merges">
                                <template v-if="merge.id !== mail.id">
                                    <option :value="merge.id">
                                        <strong>{{merge.subject}}</strong>
                                        vom {{merge.date}}
                                    </option>
                                </template>
                            </template>
                        </select>
                    </div>

                    <div type="submit" class="cu-btn tw-mt-2" @click="mergeMail()">Zusammenfassen</div>
                </div>   
            </template>
        </div>
    </div>
</template>

<script>
    import Radio from "../Radio";
    import CheckBox from "../CheckBox";
    import BorderedInput from "../BorderedInput";

    const MailStatus = {
        STATUS_UNREAD: 1,
        STATUS_READ: 2,
        STATUS_TELKO: 3,
        STATUS_TALK: 4,
        STATUS_PROBE: 5,
        STATUS_HOLD: 6,
        STATUS_CONTRACT: 7,
        STATUS_EMPLOYED: 8,
        STATUS_DENIED: 9,
        STATUS_USER_REJECTED: 10,
        STATUS_USER_INVITED_TELKO: 11,
        STATUS_USER_INVITED_TALK: 12,
        STATUS_USER_INVITED_PROBE: 13,
        STATUS_DENIED_AFTER_APPOINTMENT: 14,
        STATUS_DENIED_CONTRACT: 15,
        STATUS_HIRED: 16,
        STATUS_AUTOMATIC_DENIED: 17,
        STATUS_AUTOMATIC_DENIED_NOT_REACHED: 18,
        STATUS_AUTOMATIC_REFUSED: 19,
        STATUS_USER_INVITED_PROBE_AND_HR_MADE_PROBE_CONTRACT: 20,
    };

    const MailDepartmentStatus = {
        STATUS_UNREAD: 'unread',
        STATUS_READ: 'read',
        STATUS_DENIED: 'denied',
        STATUS_INVITE_PHONE: 'invite phone',
        STATUS_INVITE_INTERVIEW: 'invite interview',
        STATUS_INVITE_TRIAL_WORK: 'invite trial work',
        STATUS_REINVITE_PHONE: 'reinvite phone',
        STATUS_REINVITE_INTERVIEW: 'reinvite interview',
        STATUS_REINVITE_TRIAL_WORK: 'reinvite trial work',
        STATUS_USER_REJECTED: 'user rejected',
        STATUS_INVITED_PHONE: 'invited phone',
        STATUS_INVITED_INTERVIEW: 'invited interview',
        STATUS_INVITED_TRIAL_WORK: 'invited trial work',
        STATUS_REINVITED_PHONE: 'reinvited phone',
        STATUS_REINVITED_INTERVIEW: 'reinvited interview',
        STATUS_REINVITED_TRIAL_WORK: 'reinvited trial work',
        STATUS_DENIED_AFTER_APPOINTMENT: 'denied after appointment',
        STATUS_HOLD: 'hold',
        STATUS_CONTRACT: 'contract',
        STATUS_DENIED_CONTRACT: 'denied contract',
        STATUS_HIRED: 'hired',
        STATUS_AUTOMATIC_DENIED: 'auto denied',
        STATUS_AUTOMATIC_DENIED_NOT_REACHED: 'not reached auto denied',
        STATUS_AUTOMATIC_REFUSED: 'auto refused',
    };

    export default {
        components: {
            Radio,
            CheckBox,
            BorderedInput,
        },

        props: {
            mail: {
                required: true,
                type: Object,
            },
            merges: {
                required: false,
                type: [Object, Array],
                default: null,
            },
            answer_url: {
                required: true,
                type: String,
            },
            user: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                isDropdownOpen: false,
                isLoading: false,
                csrfToken: null,
                MailStatus: MailStatus,
                MailDepartmentStatus: MailDepartmentStatus,

                applicantGender: null,
                applicantName: this.mail.from_name,

                validationErrors: {},
            }
        },

        methods: {
            onClose() {
                this.isDropdownOpen = false;
            },
            deleteMail() {
                let id = 1;
                if (window.confirm('Willst du diese Mail wirklich löschen?')) {
                    this.isLoading = true;

                    axios.post('/application/delete/' + this.mail.id, {
                        
                    })
                    .then(response => {
                        this.isLoading = false;
                        window.location.href = '/applications/inbox';
                        $('[data-filename="' + id + '"]').closest('tr').fadeOut("slow");
                    })
                    .catch(error => {
                        if (!! error.response.data.errors) {
                            toast("Whoops. Hier ist etwas schief gegangen :(");
                            console.debug(response);
                        }
                    })
                    .then(() => {
                        this.isLoading = false;
                    });
                }
            },
            hardDeleteMail()  {
                let id = 1;
                if (window.confirm('Willst du diese Mail und alles dazugehörige wirklich löschen?')) {
                    this.isLoading = true;

                    axios.post('/application/hard_delete/' + this.mail.id, {
                        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
                    })
                    .then(response => {
                        this.isLoading = false;
                        window.location.href = "/applications/inbox";
                        $('[data-filename="'+id+'"]').closest('tr').fadeOut('slow');
                    })
                    .catch(error => {
                        if (!! error.response.data.errors) {
                            toast("Whoops. Hier ist etwas schief gegangen :(");
                            console.debug(response);
                        }
                    })
                    .then(() => {
                        this.isLoading = false;
                    });
                }
            },
            mergeMail() {
                this.isLoading = true;
                let mergeInId = document.getElementById('merge_in_id').value;
                if(window.confirm('Willst du diese Mail wirklich mit einer anderen zusammenfassen?')) {
                    axios.post('/application-merge', {
                        mail_id: parseInt(this.mail.id),
                        merge_in_id: mergeInId,
                    })
                    .then(response => {
                        this.isLoading = false;
                        window.location = '/inbox/application/' + mergeInId;
                        $('[data-filename="' + id + '"]').closest('tr').fadeOut("slow");
                    })
                    .catch(error => {
                        if (!! error.response.data.errors) {
                            toast("Whoops. Hier ist etwas schief gegangen :(");
                            console.debug(response);
                        }
                    })
                    .then(() => {
                        this.isLoading = false;
                    });
                }
            },
            forwardMail() {
                this.isLoading = true;
                let forward_email = document.getElementById('forward_email').value;
                axios.post('/application-department-move-mail', {
                    mail_id: parseInt(this.mail.id),
                    email: forward_email,
                })
                .then(response => {
                    this.isLoading = false;
                    window.location = '/applications/inbox';
                    $('[data-filename="' + id + '"]').closest('tr').fadeOut("slow");
                })
                .catch(error => {
                    if (!! error.response.data.errors) {
                        toast("Whoops. Hier ist etwas schief gegangen :(");
                        console.debug(response);
                    }
                })
                .then(() => {
                    this.isLoading = false;
                });
            },
        },

        mounted() {
            this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
        }
    }
</script>